module.exports = __webpack_public_path__ + "static/img/copy-item.26244ff7.svg";